import { API_DOCMAGIC_GENERATE, API_DOCMAGIC_HISTORY, API_DOCMAGIC_HISTORY_BY_ID, API_DOCMAGIC_PACKAGES } from 'config'
import Api from 'services/api'

export const getDocMagicPackages = () => {
  return Api.get(API_DOCMAGIC_PACKAGES)
}

export const generateDocMagicPackage = (data: { packageType: string; planCode?: string; noteRate?: number }) => {
  return Api.post(API_DOCMAGIC_GENERATE, data, {}, { timeout: 180000 })
}

export const getDocMagicHistory = () => {
  return Api.get(API_DOCMAGIC_HISTORY)
}

export const getDocMagicHistoryById = (id: number) => {
  return Api.get(API_DOCMAGIC_HISTORY_BY_ID, {}, { id })
}
